// extracted by mini-css-extract-plugin
export default {"intro":"nU7Ih","video":"X0LSw","fallback":"zTzms"};